import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const ListCategoryAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.fullAccess,
  routes: [
    {
      path: routesUrl.listCat,
      component: React.lazy(() => import('./pages/ListCategoryPage')),
      exact: true,
      auth: authRoles.fullAccess,
    },
  ],
};

export default ListCategoryAppConfig;
